import { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import { EditorialProjectCard } from '../components/EditorialProjectCard';
import { supabase } from '../lib/supabase';
import type { Project } from '../types';

interface ProjectsProps {
  preview?: boolean;
}

export function Projects({ preview = false }: ProjectsProps) {
  const [projects, setProjects] = useState<Project[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const { data, error } = await supabase
          .from('projects')
          .select('id, title, slug, description, category, featured_image, gallery_images, tech_stack, status')
          .order('created_at', { ascending: false });

        if (error) {
          console.error('Error fetching projects:', error);
          setProjects([]);
        } else {
          setProjects((data || []) as Project[]);
        }
      } catch (error) {
        console.error('Error fetching projects:', error);
        setProjects([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjects();
  }, []);

  if (isLoading) {
    return (
      <div className="space-y-32">
        <div className="flex items-center justify-center py-12">
          <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  const displayedProjects = preview ? projects.slice(0, 4) : projects;

  return (
    <div className="space-y-32">
      <AnimatePresence>
        {displayedProjects.map((project, index) => (
          <EditorialProjectCard 
            key={project.id} 
            id={project.id}
            slug={project.slug}
            title={project.title}
            description={project.description || ''}
            category={project.category || 'Uncategorized'}
            image={project.featured_image || project.gallery_images?.[0]}
            index={index}
          />
        ))}
      </AnimatePresence>
    </div>
  );
}